import { tracking as initialState } from 'flux/initialState'
import { tracking as actions } from 'flux/actions'

export default function (state = initialState, action) {
  const { types } = actions

  switch (action.type) {
    case types.SET_SESSION_FLYER_ID: {
      const { flyerId } = action.payload
      return {
        ...state,
        sessionFlyerId: flyerId,
      }
    }

    case types.HIT_VIEWER_PERCENTAGE: {
      const { flyerId, reachedPercentage } = action.payload
      return {
        ...state,
        viewerPercentages: {
          ...state.viewerPercentages,
          [flyerId]: {
            ...state.viewerPercentages[flyerId],
            [reachedPercentage]: true,
          },
        },
      }
    }
    default:
      return state
  }
}
